import React, { Component } from 'react';
import axios from 'axios';
import { apiEndpoints } from '../../../config/config';

import { Formik, Form, Field } from 'formik';

class ContactForm extends Component {
  state = {
    name: '',
    email: '',
    message: '',
    companyName: '',
    companyWebsite: ''
  };

  handleChange = event => {
    const target = event.target;
    const value = target.value;
    const name = target.name;
    // console.log('value: ', value);

    this.setState({
      [name]: value
    });
  };

  handleSubmit = event => {
    const { state } = this;
    event.preventDefault();
    const url = apiEndpoints.contactForm;
    // console.log('url: ', url);
    // console.log(state);
    if (state.name && state.email && state.message) {
      axios.post(url, state);
    } else {
      // Handle in Form Validation
    }
  };

  validateEmail = value => {
    let error;
    if (!value) {
      error = 'Required';
    } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value)) {
      error = 'Invalid email address';
    }
    return error;
  };

  validateName = value => {
    let error;
    if (!value) {
      error = 'Required';
    } else if (value === 'admin' || value.length < 4) {
      error = 'Please enter your Full Name';
    }
    return error;
  };

  validateMessage = value => {
    let error;
    if (!value) {
      error = 'Required';
    } else if (value === 'admin' || value.length < 4) {
      error = 'Please enter message';
    }
    return error;
  };

  render() {
    const { full } = this.props;
    if (full) {
      // console.log('Full');
    }

    // return (
    //   <form className="form w-100 mw6 mh3" onSubmit={this.handleSubmit}>
    //     <div className="field">
    //       <div className="control">
    //         <input
    //           className="input w-100 br2 bg-white bn ph3 pv2 shadow-4 mb3"
    //           style={{ height: '3rem' }}
    //           type="text"
    //           name="name"
    //           placeholder="Your Name"
    //           value={this.state.name}
    //           onChange={this.handleChange}
    //         />
    //       </div>
    //     </div>

    //     {full ? (
    //       <div className="field">
    //         <div className="control">
    //           <input
    //             className="input w-100 br2 bg-white bn ph3 pv2 shadow-4 mb3"
    //             style={{ height: '3rem' }}
    //             type="text"
    //             name="companyName"
    //             placeholder="Your Company Name"
    //             value={this.state.companyName}
    //             onChange={this.handleChange}
    //           />
    //         </div>
    //       </div>
    //     ) : null}

    //     <div className="field">
    //       <div className="control">
    //         <input
    //           className="input w-100 br2 bg-white bn ph3 pv2 shadow-4 mb3"
    //           style={{ height: '3rem' }}
    //           type="email"
    //           name="email"
    //           placeholder="Your Email"
    //           value={this.state.email}
    //           onChange={this.handleChange}
    //         />
    //       </div>
    //     </div>

    //     {full ? (
    //       <div className="field">
    //         <div className="control">
    //           <input
    //             className="input w-100 br2 bg-white bn ph3 pv2 shadow-4 mb3"
    //             style={{ height: '3rem' }}
    //             type="text"
    //             name="companyWebsite"
    //             placeholder="Your Company Website (optional)"
    //             value={this.state.companyWebsite}
    //             onChange={this.handleChange}
    //           />
    //         </div>
    //       </div>
    //     ) : null}

    //     <div className="field">
    //       <div className="control">
    //         <textarea
    //           className="textarea w-100 h4 br2 bg-white bn ph3 pb2 pt3 shadow-4 mb3 mt3"
    //           name="message"
    //           placeholder="Your Message"
    //           value={this.state.message}
    //           onChange={this.handleChange}
    //         />
    //       </div>
    //     </div>

    //     <div className="field">
    //       <div className="control flex justify-end">
    //         <input
    //           type="submit"
    //           value="Submit"
    //           className="button outline-0 pointer b"
    //           style={{
    //             background: '#4db2ec',
    //             width: '160px',
    //             height: '40px',
    //             border: 'solid 1.8px #4db2ec',
    //             borderRadius: '24px',
    //             color: '#f3f4f6',
    //             fontFamily: 'Montserrat',
    //             fontSize: '1.25rem'
    //           }}
    //         />
    //       </div>
    //     </div>
    //   </form>
    // );

    return (
      <Formik
        initialValues={{ email: '', name: '', message: '' }}
        onSubmit={values => {
          // console.log('values: ', values);
          axios.post(`${apiEndpoints.contactForm}`, values);
        }}
      >
        {({
          validateField,
          validateForm,
          errors,
          touched,
          handleChange,
          handleBlur,
          handleSubmit,
          isSubmitting
          /* and other goodies */
        }) => (
          <Form onSubmit={handleSubmit}>
            <span className="red">
              {errors.name && touched.name && errors.name}
            </span>
            <Field
              className="contact-input br2 bg-white bn ph3 pv2 shadow-4 mb3"
              name="name"
              validate={this.validateName}
              placeholder="Full Name"
            />

            {full ? (
              <Field
                className="contact-input br2 bg-white bn ph3 pv2 shadow-4 mb3"
                name="companyName"
                // validate={this.validateCompanyName}
                placeholder="Company Name (optional)"
              />
            ) : null}

            <span className="red">
              {errors.email && touched.email && errors.email}
            </span>
            <Field
              className="contact-input br2 bg-white bn ph3 pv2 shadow-4 mb3"
              name="email"
              validate={this.validateEmail}
              placeholder="Email"
            />

            {full ? (
              <Field
                className="contact-input br2 bg-white bn ph3 pv2 shadow-4 mb3"
                name="companyWebsite"
                // validate={this.validateCompanyName}
                placeholder="Company Website (optional)"
              />
            ) : null}

            <span className="red">
              {errors.message && touched.message && errors.message}
            </span>
            <Field
              className="contact-input message h4 br2 bg-white bn ph3 pb2 pt3 shadow-4 mb3"
              name="message"
              component="textarea"
              validate={this.validateMessage}
              placeholder="Message"
            />
            <div
              className="contact-submit"
              // style={{
              //   background: '#4db2ec',
              //   width: '160px',
              //   height: '40px',
              //   border: 'solid 1.8px #4db2ec',
              //   borderRadius: '24px',
              //   color: '#f3f4f6',
              //   fontFamily: 'Montserrat',
              //   fontSize: '1.25rem'
              // }}
            >
              <button
                className="grow"
                disabled={errors.name || errors.email || errors.message}
                style={{
                  background:
                    errors.name || errors.email || errors.message
                      ? 'grey'
                      : '#4db2ec',
                  width: '160px',
                  height: '40px',
                  // border: 'solid 1.8px #4db2ec',
                  borderRadius: '24px',
                  color: '#f3f4f6',
                  fontFamily: 'Montserrat',
                  fontSize: '1.25rem',
                  cursor: 'pointer'
                }}
                type="submit"
              >
                Submit
              </button>
            </div>
          </Form>
        )}
      </Formik>
    );
  }
}

export default ContactForm;
